import { useEffect, useState} from 'react';
import axios from 'axios';
import { API_ENDPOINTS } from '../apiEndpoints';
import { apiRequest } from '@/network/apiClient';

export const useGetOpportunityInfoGather = ({oppID, funnel}) => {
    const [oppDetails, setOppDetails] = useState(null);

    const fetchData = async () => {
        try {
            const queryParams = new URLSearchParams({
                sub_id: oppID
            })
            const result = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_OPPORTUNITIES.INFO_GATHERING}/${funnel}?${queryParams.toString()}`)
            setOppDetails(result);
        }catch (error) {
            console.error("Error fetching opportunity info gather data:", error);
        };
    };

    useEffect(() => {
        if (!oppID) return;
        fetchData();
    }, [oppID, funnel]);

    return {oppDetails, refetch: fetchData};
}